var _analyticsTrackerLoaded = false;

/**
   * An object to manage Google Analytics as a TrackerManager plugin
   * @constructs AnalyticsTracker
   * @memberof Class
   * @author Bruno Sabot
   */
function AnalyticsTracker(serverConfNode) {
	this.account = serverConfNode.account;
	this.name = serverConfNode.name;
	this.label = serverConfNode.label;
	this.session = serverConfNode.session;

	// The tracker name should be only lowercase chars and numbers
	this.trackerName = 'tracker' + this.account.replace(/-/gi, '').toLowerCase();
	this.loadTracker();

	var params = {};

	ga('create', this.account, 'none', this.trackerName, params);

	if (serverConfNode.name !== undefined) {
		ga(this.trackerName + '.set', 'dimension1', this.name);
	}

	for (var i = 1; i < 10; i++) {
		if (serverConfNode['dimension' + i] !== undefined) {
			ga(this.trackerName + '.set', 'dimension' + i, serverConfNode['dimension' + i]);
		}
	}

	ga(this.trackerName + '.set', 'checkProtocolTask', null); // needed for the app version, checkProtocolTask prevent sending hit if the url is file:// instead of http(s)://, removing this function fixes the problem
	ga(this.trackerName + '.set', 'checkStorageTask', null); // needed for the app version, checkStorageTask prevent sending hit
}

AnalyticsTracker.prototype.isLoaded = function () {
	return _analyticsTrackerLoaded;
}

/**
 * Load the analytics tracker
 * @author Bruno Sabot
 */
AnalyticsTracker.prototype.loadTracker = function() {

	if (_analyticsTrackerLoaded) {
		return;
	}
	
	var libUrl = 'https://www.google-analytics.com/analytics.js';
	// libUrl = 'https://www.google-analytics.com/analytics_debug.js';

	// Inclusion du script Google Analytics
	(function (i, s, o, g, r, a, m) {

		i.GoogleAnalyticsObject = r;
		if (!i[r]) {
			i[r] = function () {
				(i[r].q = i[r].q || []).push(arguments);
			};
			i[r].l = 1 * new Date();
		}
		a = s.createElement(o);
		m = s.getElementsByTagName(o)[0];
		a.async = 1;
		a.onload = function () {
			_analyticsTrackerLoaded = true;
		};
		a.src = g;
		m.parentNode.insertBefore(a, m);

	})(window, document, 'script', libUrl, 'ga');


};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Bruno Sabot
 */
AnalyticsTracker.prototype.trackPage = function(page, url, title) {
	// window.ga_debug = { trace: true };

	var prefix = this.label ? this.label : '';
	var location = window.location.href;
	if (this.label) {
		location = window.location.href.replace(
			window.location.origin,
			window.location.origin + '/' + prefix
		);
	}

	// Mandatory data
	var data = {
		"hitType": "pageview",
		"page": prefix + url
	};

	// Optionnal data
	if (title) {
		data.title = title;
	}

	// Track
	ga(this.trackerName + '.set', 'location', location);
	ga(this.trackerName + '.send', data);

};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Bruno Sabot
 */
AnalyticsTracker.prototype.trackEvent = function(category, action, label, value) {

	// Mandatory data
	var data = {
		"hitType": "event",
		"eventCategory": category,
		"eventAction": action
	};

	// Optionnal data
	if (label) {
		data.eventLabel = label;
	}

	if (value) {
		data.eventValue = value;
	}

	// Track
	ga(this.trackerName + '.send', data);

};

module.exports = AnalyticsTracker;


//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/analyticsTracker.js
// module id = 628
// module chunks = 0